import { Injectable } from '@angular/core';
import { ThemeMode } from '@fleet-beat/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeModeService {
  themeModeSubject: BehaviorSubject<ThemeMode> = new BehaviorSubject(undefined);
  private readonly defaultThemeMode: ThemeMode = ThemeMode.LIGHT;

  getCurentTheme(): ThemeMode {
    return localStorage.getItem('themeMode') as ThemeMode;
  }

  changeThemeMode(mode: ThemeMode): void {
    this.themeModeSubject.next(mode);
    localStorage.setItem('themeMode', mode);
  }

  setDefaultThemeMode(): void {
    const localStorageThems: ThemeMode = localStorage.getItem('themeMode') as ThemeMode;
    if (!localStorageThems) localStorage.setItem('themeMode', this.defaultThemeMode);
    this.themeModeSubject.next(localStorageThems ? localStorageThems : this.defaultThemeMode);
  }
}
